import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Inbox } from 'lucide-react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { NavLink } from 'react-router-dom';
import { activeNetworkSelector } from '../../../redux/selectors';
import useIntroductionRequests from '../../../hooks/useIntroductionRequests';

export const NavFooter = () => {
  const activeNetwork = useSelector(activeNetworkSelector);
  const { isManager, features } = activeNetwork;
  const showInbox = useMemo(() => isManager && features && features.includes('talent_network'), [isManager, features]);
  const [introductionRequests] = useIntroductionRequests(activeNetwork);
  const introductionRequestsCount = useMemo(
    () => (introductionRequests ? introductionRequests.length : 0),
    [introductionRequests],
  );

  return (
    <Box>
      {showInbox && (
        <Flex
          as={NavLink}
          to={`/networks/${activeNetwork.slug}/inbox`}
          exact
          sx={{
            alignItems: 'center',
            position: 'relative',
            width: '100%',
            height: '36px',
            flex: '0 0 auto',
            py: '8px',
            pl: '12px',
            textDecoration: 'none',
            gap: '12px',
          }}
        >
          <Box as={Inbox} width="16px" height="16px" aria-hidden="true" />
          <Text
            textAlign="left"
            fontSize="14px"
            fontWeight="medium"
            flexGrow="1"
            className="main-menu-item"
            sx={{
              whiteSpace: 'nowrap',
            }}
          >
            Inbox
          </Text>
          {introductionRequestsCount > 0 && (
            <Box
              sx={{
                position: 'absolute',
                top: '10px',
                left: '22px',
                width: '8px',
                height: '8px',
                borderRadius: 'circle',
                bg: 'primary',
              }}
            />
          )}
        </Flex>
      )}
    </Box>
  );
};
